import "@/scss/glightbox.scss";

import GLightbox from "glightbox";

const FORM_FETCH_OPTIONS = {
  method: "GET",
  cache: "no-cache",
  credentials: "same-origin",
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
};

const FORM_HEADER_FIELDS = [
  { key: "heading", tag: "h3", className: "text-2xl md:text-3.5xl font-bold mb-3" },
  { key: "subheading", tag: "h4", className: "text-xl font-bold mb-3" },
  { key: "text", tag: "div", className: "mb-3" },
];

export function globalAutoPopup(config = {}) {
  return {
    hideAfterCloseDays: Number(config.hideAfterCloseDays) || 0,
    appearAfterMs: (Number(config.appearAfterSeconds) || 0) * 1000,
    cookieName: "global-entry-popup-visited",
    isOpen: false,
    lightbox: null,

    init() {
      if (this.hideAfterCloseDays > 0 && window.getCookie?.(this.cookieName) === "1") {
        return;
      }

      this.openWhenReady();
    },

    get trigger() {
      return this.$refs.trigger || null;
    },

    markClosed() {
      this.isOpen = false;
      if (this.hideAfterCloseDays > 0) {
        const expiresAt = new Date();
        expiresAt.setTime(expiresAt.getTime() + (this.hideAfterCloseDays * 24 * 60 * 60 * 1000));
        document.cookie = `${this.cookieName}=1;expires=${expiresAt.toUTCString()};path=/`;
      }
    },

    openWhenReady() {
      if (!this.trigger) {
        return;
      }

      if (!this.lightbox) {
        this.lightbox = GLightbox({
          selector: "#global-auto-popup-inline-trigger",
          closeButton: true,
          onClose: () => this.markClosed(),
        });
      }

      setTimeout(() => {
        this.lightbox.reload();
        this.trigger.click();
        this.isOpen = true;
      }, Math.max(this.appearAfterMs, 100));
    },

    handleCloseClick(event) {
      if (this.isOpen && event.target.closest(".gclose, .goverlay")) {
        this.markClosed();
      }
    },

    handleFormClick(event) {
      const clickedButton = event.target.closest(".gslide.current .js-global-popup-open-form");
      if (!clickedButton) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();

      if (clickedButton.dataset.loading === "true") {
        return;
      }

      const panel =
        clickedButton.closest("#global-entry-popup-panel") ||
        document.querySelector(".gslide.current #global-entry-popup-panel");

      if (!panel || !clickedButton.dataset.form) {
        return;
      }

      clickedButton.dataset.loading = "true";
      const originalText = clickedButton.textContent;
      clickedButton.textContent = "Loading...";

      fetch(this.getFormUrl(clickedButton), FORM_FETCH_OPTIONS)
        .then((response) => response.text())
        .then((html) => this.replaceWithForm(panel, clickedButton, html))
        .catch(() => {
          clickedButton.dataset.loading = "false";
          clickedButton.textContent = originalText;
        });
    },

    getFormUrl(button) {
      const apiForm = button.getAttribute("data-apiForm") || "form";
      return `/apis/${apiForm}?form=${encodeURIComponent(button.dataset.form)}`;
    },

    getHeaderHtml(button) {
      return FORM_HEADER_FIELDS
        .map(({ key, tag, className }) => {
          const value = button.dataset[key]?.trim();
          return value ? `<${tag} class="${className}">${value}</${tag}>` : "";
        })
        .join("");
    },

    replaceWithForm(panel, button, html) {
      const lightboxPanel = panel.closest(".gslide-inline");
      const inlineContent = panel.closest(".ginlined-content");

      if (lightboxPanel) {
        lightboxPanel.style.width = "min(96vw, 1200px)";
        lightboxPanel.style.maxWidth = "1200px";
        lightboxPanel.style.height = "calc(100vh - 40px)";
        lightboxPanel.style.maxHeight = "calc(100vh - 40px)";
      }

      if (inlineContent) {
        inlineContent.style.height = "100%";
      }

      panel.className = "w-full h-full bg-gray-50 rounded-xl border-t-[10px] border-orange-500 p-5 md:p-10 overflow-y-auto";
      panel.innerHTML = this.getHeaderHtml(button) + html;

      setTimeout(() => {
        if (window.Formie && typeof window.Formie.initForms === "function") {
          window.Formie.initForms();
        }
        window.dispatchEvent(new Event("resize"));
      }, 50);
    },
  };
}
